<template>
  <FilterGroup title="Dates">
    <FilterButton
      label="En cours / à venir"
      icon="calendar-check"
      color="blue"
      :active="filter === 'active'"
      @click.native="$emit('updateFilter', 'active')"
    />
    <FilterButton
      label="Passé"
      icon="archive"
      color="gray"
      :active="filter === 'archived'"
      @click.native="$emit('updateFilter', 'archived')"
    />
  </FilterGroup>
</template>

<script>
import FilterButton from './FilterButton.vue';
import FilterGroup from './FilterGroup.vue';

export default {
  components: {
    FilterButton,
    FilterGroup,
  },
  props: ['filter'],
};
</script>
